import type * as React from 'react';
import { type SearchableFieldSelect } from '../../ISearchableField.tsx';

/**
 * Formatter per i campi di tipo `Select` / `Radio`. Cerca l'option corrispondente
 * al valore (match per coercion a stringa per gestire boolean/number) e
 * restituisce la sua `label`. Se nessuna option matcha, ricade su `String(value)`.
 */
export function formatSelectFilterBarValue(
  field: SearchableFieldSelect,
  value: unknown,
): React.ReactNode {
  // Vuoto legittimo (Select/Radio non selezionato): nessun chip, niente warn.
  if (value === null || value === undefined) {
    return null;
  }

  // Le `option.value` sono `string | number | boolean` per definizione di
  // SearchableFieldSelect; tutto il resto non è rappresentabile come chip.
  // Non dovrebbe mai capitare: lo segnaliamo per intercettare valori anomali.
  if (
    typeof value !== 'string' &&
    typeof value !== 'number' &&
    typeof value !== 'boolean'
  ) {
    console.warn(
      '[formatSelectFilterBarValue] Valore select di tipo non gestito',
      { field, value },
    );
    return null;
  }
  const option = field.options.find(o => String(o.value) === String(value));
  return option?.label ?? String(value);
}
